export default {
  pageSize: (state) => state.pageSize,
  searchTerm: (state) => state.searchTerm,
  filterOptions: (state) => state.filterOptions,
  filterBy: (state) => state.filterBy,
  sortDir: (state) => state.sortDir,
  orderBy: (state) => state.orderBy,
  locationTree: (state) => state.locationTree,
  networkTree: (state) => state.networkTree,
  locations: (state) => state.locations,
  location: (state) => state.location,
  locationsFound: (state) => state.locationsFound,
  preferences: (state) => state.preferences,
  insuranceFound: (state) => state.insuranceFound,
  insurance: (state) => state.insurance,
  providerFound: (state) => state.providerFound,
  providers: (state) => state.providers,
  addLocation: (state) => state.addLocation,
  foundLocations: (state) => state.foundLocations,
  calibrationPricing: (state) => state.calibrationPricing
}



// WEBPACK FOOTER //
// ./src/store/modules/locations/getters.js